query Campaigns($clientId: ID!, $orderBy: CampaignOrderBy, $wppProjectId: String) {
    client(id: $clientId) {
        _id
        id
    }
    campaigns(clientId: $clientId, orderBy: $orderBy, wppProjectId: $wppProjectId) {
        _id
        id
        mastheadImageUrl
        name
        jiraTicketUrl
        wppProjectId
        section {
            _id
        }
    }
}
